import { Component, Inject, OnInit } from "@angular/core";
import { BASE_API_URL } from "../../core/environment.tokens";
import { DynamicInput } from "../../dynamic-forms/inputs/dynamic-input.model";
import { Textbox } from "../../dynamic-forms/inputs/textbox/textbox.model";
import { BulkAction } from "../../shared/grid/bulk-actions/bulk-action.model";
import { GridPipeName } from "../../shared/grid/grid-pipe.enum";
import { GridColumnDefinition } from "../../shared/grid/models/grid-column-definition.model";
import { GridConfiguration } from "../../shared/grid/models/grid-configuration.model";
import { GridFilter } from "../../shared/grid/models/grid-filter.model";
import { GridRequest } from "../../shared/grid/models/grid-request.model";
import { DateFormats } from "../../utilities/contracts/helper-types";

@Component({
  selector: "toolbox-basic-grid-demo",
  templateUrl: "./basic-grid-demo.component.html",
  styleUrls: ["./basic-grid-demo.component.scss"],
})
export class BasicGridDemoComponent implements OnInit {
  basicGridConfiguration: GridConfiguration;
  basicGridData: any[] = [];
  basicGridSelection: any;

  serverGridConfiguration: GridConfiguration;
  serverRequest: GridRequest;
  serverGridSelection: any;

  get chaseIdInput(): DynamicInput {
    return this.serverRequest.getInput("ChaseId");
  }

  constructor(@Inject(BASE_API_URL) private readonly baseApiUrl: string) { }

  ngOnInit() {
    // BASIC
    this.basicGridConfiguration = new GridConfiguration({
      columns: [
        new GridColumnDefinition({
          field: "firstName",
          header: "First Name",
          width: "16%",
        }),
        new GridColumnDefinition({
          field: "lastName",
          header: "Last Name",
          width: "16%",
        }),
        new GridColumnDefinition({
          field: "phoneNumber",
          header: "Phone",
          width: "16%",
          pipeName: GridPipeName.Phone,
        }),
        new GridColumnDefinition({
          field: "age",
          header: "Age",
          width: "8%",
          styles: (value: number, rowData: any) => {
            const isOld = value > 30;
            const color = isOld ? "red" : "green";
            return { color };
          },
        }),
        new GridColumnDefinition({
          field: "phrase",
          header: "Phrase",
          routeUrl: "#",
          width: "60%",
        }),
      ],
      pageSize: 3,
      selectionMode: "multiple",
      bulkActions: [
        new BulkAction({
          name: "Print Items",
          action: items => console.log(items),
          disabled: true,
          showBulkAction: true,
        }),
        new BulkAction({
          name: "Copy",
          action: items => console.log(items),
        }),
        new BulkAction({
          name: "Cat",
          action: () => console.log("Cat"),
        }),
      ],
      showRowExpansionColumn: true,
      trackByField: "firstName",
    });
    this.basicGridData = [
      { phoneNumber: "3105555555", firstName: "Pete", lastName: "Schumer", age: 34, phrase: "Kowabonga!" },
      { phoneNumber: "3105555555", firstName: "Tommy", lastName: "Boy", age: 56, phrase: "That is correct!" },
      { phoneNumber: "3105555555", firstName: "Susan", lastName: "Magic", age: 27, phrase: "It's always dangerous to stare at goats in the face!" },
      { phoneNumber: "3105555555", firstName: "Mike", lastName: "Meyers", age: 16, phrase: "Yeah Baby!" },
      { phoneNumber: "3105555555", firstName: "Angela", lastName: "Adams", age: 97, phrase: "What did you say? I'm old. I can't hear anything. You should know that." },
    ];

    // SERVER
    this.serverGridConfiguration = new GridConfiguration({
      // stateName: "toolbox", // <== To add session state
      columns: [
        new GridColumnDefinition({ field: "chaseID", header: "Chase" }),
        new GridColumnDefinition({ field: "memberFirstName", header: "First", title: "memberDateOfBirth" }),
        new GridColumnDefinition({ field: "memberLastName", header: "Last" }),
        new GridColumnDefinition({ field: "memberDateOfBirth", header: "DOB", pipeName: GridPipeName.Date, format: DateFormats.GRID_DATE_FORMAT }),
        new GridColumnDefinition({ field: "providerCount", header: "Provider Count" }),
        new GridColumnDefinition({ field: "projectName", header: "Project" }),
        new GridColumnDefinition({ field: "measureCode", header: "Measure" }),
        new GridColumnDefinition({ field: "workflowStatusName", header: "Status" }),
        new GridColumnDefinition({ field: "chartCommitDate", header: "Commit" }),
        new GridColumnDefinition({ field: "scheduledDate", header: "Sched." }),
        new GridColumnDefinition({ field: "pendCode", header: "Pend" }),
      ],
      pageSize: 3,
      selectionMode: "single",
      showRowExpansionColumn: true,
      trackByField: "chaseID",
    });
    this.serverRequest = new GridRequest({
      url: `${this.baseApiUrl}chase/list`,
      filters: [
        new GridFilter({
          input: new Textbox(),
          key: "ChaseId",
          // value: "123456",
          // show: false, // <== add if you want to hide
        }),
      ],
    });
  }

  printActionArgumentsToConsole(index: number, rowData: any): void {
    console.log("Index", index);
    console.log("Print Row Data:", rowData);
    console.log("All Data", this.basicGridData);
  }
}
